import { cn } from "@/lib/utils";
import React, { useMemo } from "react";
import TimeOfMsg from "./TimeOfMsg";

const ChatBubble = ({
  id,
  msg,
  senderId,
  userId,
}: {
  userId?: string | null;
  senderId: string | null;
  id: number;
  msg: string;
}) => {
  const isCurrentUser = useMemo(() => senderId === userId, [senderId, userId]);
  return (
    <div
      className={cn("chat", {
        "chat-start": isCurrentUser,
        "chat-end": !isCurrentUser,
      })}
      data-date={id}
    >
      <div
        className={cn("flex items-end gap-4 flex-row", {
          "flex-row-reverse": !isCurrentUser,
        })}
      >
        <div
          className={cn(
            "rounded-xl px-4 py-2 sm:max-w-xl max-w-xs break-words bg-[#F1F1F1] text-black",
            { "bg-[#56C447] text-white": isCurrentUser }
          )}
        >
          {msg}
          <TimeOfMsg
            id={id}
            className={cn("sm:hidden text-end", {
              "text-end": isCurrentUser,
            })}
          />
        </div>
        <TimeOfMsg id={id} className="max-sm:hidden" />
      </div>
    </div>
  );
};

export default ChatBubble;
